const calFontStyle = (
	font,
	size,
	lineHeight = 'normal',
	letterSpacing = 'normal'
) => {
	return `
        font-family: ${font};
        font-size: ${size};
        line-height: ${lineHeight};
        letter-spacing: ${letterSpacing};
    `
}

const font = {
	'xtiny-light': calFontStyle('light', '8px'),
	'xtiny-regular': calFontStyle('regular', '8px'),
	'xtiny-medium': calFontStyle('medium', '8px'),
	'xtiny-semibold': calFontStyle('semibold', '8px'),
	'xtiny-bold': calFontStyle('bold', '8px'),

	'tiny-light': calFontStyle('light', '9px'),
	'tiny-regular': calFontStyle('regular', '9px'),
	'tiny-medium': calFontStyle('medium', '9px'),
	'tiny-semibold': calFontStyle('semibold', '9px'),
	'tiny-bold': calFontStyle('bold', '9px'),

	'xsmall-light': calFontStyle('light', '10px'),
	'xsmall-regular': calFontStyle('regular', '10px'),
	'xsmall-medium': calFontStyle('medium', '10px'),
	'xsmall-semibold': calFontStyle('semibold', '10px'),
	'xsmall-bold': calFontStyle('bold', '10px'),

	'small-light': calFontStyle('light', '12px'),
	'small-regular': calFontStyle('regular', '12px'),
	'small-medium': calFontStyle('medium', '12px'),
	'small-semibold': calFontStyle('semibold', '12px'),
	'small-bold': calFontStyle('bold', '12px'),

	'medium-light': calFontStyle('light', '14px'),
	'medium-regular': calFontStyle('regular', '14px'),
	'medium-medium': calFontStyle('medium', '14px'),
	'medium-semibold': calFontStyle('semibold', '14px'),
	'medium-bold': calFontStyle('bold', '14px'),

	'large-light': calFontStyle('light', '16px'),
	'large-regular': calFontStyle('regular', '16px'),
	'large-medium': calFontStyle('medium', '16px'),
	'large-semibold': calFontStyle('semibold', '16px'),
	'large-bold': calFontStyle('bold', '16px'),

	'xlarge-light': calFontStyle('light', '18px'),
	'xlarge-regular': calFontStyle('regular', '18px'),
	'xlarge-medium': calFontStyle('medium', '18px'),
	'xlarge-semibold': calFontStyle('semibold', '18px'),
	'xlarge-bold': calFontStyle('bold', '18px'),

	'xxlarge-light': calFontStyle('light', '20px'),
	'xxlarge-regular': calFontStyle('regular', '20px'),
	'xxlarge-medium': calFontStyle('medium', '20px'),
	'xxlarge-semibold': calFontStyle('semibold', '20px'),
	'xxlarge-bold': calFontStyle('bold', '20px'),

	'heading-light': calFontStyle('light', '24px'),
	'heading-regular': calFontStyle('regular', '24px'),
	'heading-medium': calFontStyle('medium', '24px'),
	'heading-semibold': calFontStyle('semibold', '24px'),
	'heading-bold': calFontStyle('bold', '24px'),
}

const color = {
	// Basic List
	white: '#FFFFFF',
	grey1: '#EEF0F2',
	grey2: '#DFDFE7',
	grey3: '#B2B2B2',
	grey4: '#8D8D8D',
	black: '#1F2024',

	// State List
	error: '#ED3241',

	// Tier List
	bronze: '#E4691C',
	silver: '#DFDFE7',
	gold: '#F5C15B',
	platinum: '#1DEEEB',
	diamond: '#4882FE',
	master: '#FB392E',
	challenger: '#FB392E',

	// Highlight List
	blue: '#6381DB',
	green: '#6EC34C',
	orange: '#F78904',
	red: '#FB392E',
}

const breakpoints = {
	mobile: '768px',
	tablet: '1024px',
	desktop: '1200px',
}

const theme = {
	font,
	color,
	breakpoints,
}

export default theme
